import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import Toggle from 'react-toggle'
import { useTranslation } from 'react-i18next'

import { getCompaniesList, getPartnerCompaniesList, getCompanyProfiles } from '../../../action/CompaniesActions'
import { getCompanyGroups, addGroup } from '../../../action/GroupsActions'
import { apiCall } from '../../../action/RouterActions'

import CustomButton from '../../CustomButton'
import AutocompleteComponent from '../../common/AutocompleteComponent'
import ModalDelete from './ModalDelete'

import '../../dump/HeaderNav.sass'

const ModalDevicesMigration = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'modals.modalDevicesMigration' });
	const { user, onHide, selectedDevices, migratingDevices, companyData, loaderModal, toggleLoaderModal } = props;

	const userRole = user.roles[0];
	const [partners, setPartners] = useState([]);
	const [partner, setPartner] = useState('');
	const [companies, setCompanies] = useState([]);
	const [company, setCompany] = useState('');
	const [profiles, setProfiles] = useState([]);
	const [profile, setProfile] = useState('');
	const [cloneProfile, setCloneProfile] = useState(false);
	const [groups, setGroups] = useState([]);
	const [group, setGroup] = useState('');
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [showGroupInput, setShowGroupInput] = useState(false);
	const [isEditData, setIsEditData] = useState(false);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (!migratingDevices.length) {
			switch (userRole) {
				case 'system_admin':
				case 'customer_service':
				case 'sales_demo':
				case 'installer':
					getPartnersOrCompanies('PARTNER', false);
					break
				case 'partner':
				case 'custom_partner':
				case 'custom_user':
				case 'partner_view':
					getPartnersOrCompanies('CUSTOMER', true)
					break
				default:
					break
			}
		}
	}, []);

	const getPartnersOrCompanies = (company_type, get_type) => {
		toggleLoaderModal(true);
		getCompaniesList(userRole, company_type, get_type)
			.then((res) => {
				if (!get_type) {
					const partners = _.sortBy(res.data.response['companies list'].filter(e => !!e), e => e.toLowerCase());
					if (partners.length) {
						setPartners(partners);
						setPartner(partners[0]);
						getCompanies(partners[0]);
					} else {
						toggleLoaderModal(false);
					}
				} else {
					const companies = _.sortBy(res.data.response['companies list'].filter(e => e.name && e.name !== companyData.company_name), e => e.name.toLowerCase());
					setPartner(user.company_name);
					if (companies.length) {
						setCompanies(companies);
						setCompany(companies[0].name);
						getProfiles(user.company_name, companies[0].name);
						getGroups(user.company_name, companies[0].name);
					} else {
						toggleLoaderModal(false);
					}
				}
			})
			.catch((err) => {
				console.log(err);
				toggleLoaderModal(false);
			});
	};

	const getCompanies = (partner) => {
		toggleLoaderModal(true);
		getPartnerCompaniesList(userRole, partner, true)
			.then((res) => {
				const companies = _.sortBy(res.data.response['companies list'].filter(e => e.name && e.name !== companyData.company_name), e => e.name.toLowerCase());
				if (companies.length) {
					setCompanies(companies);
					setCompany(companies[0].name);
					getProfiles(partner, companies[0].name);
					getGroups(partner, companies[0].name);
				} else {
					setProfile('');
					setProfiles([]);
					setGroup('');
					setGroups([]);
					toggleLoaderModal(false);
				}
			})
			.catch((err) => {
				console.log(err);
				toggleLoaderModal(false);
			});
	};

	const getProfiles = (partner, company) => {
		toggleLoaderModal(true);
		getCompanyProfiles({
			user_role: userRole,
			partner_name: partner,
			company_name: company
		})
			.then((response) => {
				const profiles = _.sortBy(response.data.response.profiles.filter(e => e.name.trim()), e => e.name.toLowerCase());
				setProfiles(profiles || []);
				setProfile(profiles[0]?.name || '');
				toggleLoaderModal(false);
			})
			.catch((err) => {
				console.log(err);
				toggleLoaderModal(false);
			});
	};

	const getGroups = async (partner, company) => {
		toggleLoaderModal(true);
		const params = {
			name: company,
			partner: partner
		}
		const getids = '?getids=&include_data=active_devices'
		await getCompanyGroups(userRole, params, getids)
			.then((res) => {
				if (res.status === 200 || res.status === 201) {
					const groups = _.sortBy(res.data.response.groups.filter(e => e.group_name.trim()), e => e.group_name.toLowerCase());
					setGroups(groups || []);
					setGroup(groups[0]?.group_name || '');
					toggleLoaderModal(false);
				}
			})
			.catch((err) => {
				console.log(err);
				toggleLoaderModal(false);
			});
	}

	const addOneGroup = () => {
		const state = {
			partner_name: partner,
			company_name: company,
			group_name: inputValue
		};

		if (partner && company) {
			toggleLoaderModal(true);
			addGroup(state, userRole)
				.then(res => {
					toggleLoaderModal(false);
					setGroup(inputValue);
					closeGroupInput();
					toastr.success("Success", t('groupAdded'));
					getGroups(partner, company);
				})
				.catch((err) => {
					toggleLoaderModal(false);
					console.log(err);
					toastr.error(t('unableAddGroup'))
				});
		}
	}

	const saveChanges = () => {
		toggleLoaderModal(true);
		const params = {
			target_company_profile_id: _.find(profiles, e => (e.name === profile)).id,
			target_device_group_id: _.find(groups, e => (e.group_name === group)).id,
			device_ids: selectedDevices,
		};
		apiCall('POST', `/companies/${_.find(companies, e => (e.name === company)).id}/devices/migration`, params).
			then((res) => {
				toastr.success("Success", t('textDevicesMigration'));
				setShowConfirmModal(false);
				onHide();
				toggleLoaderModal(false);
			})
			.catch(err => {
				toggleLoaderModal(false);
				console.log(err);
				toastr.error(i18n.t('errorMessage.errDescription'));
			});
	}

	const toggleCloneProfile = (e) => {
		const value = e.target.checked;
		setCloneProfile(value);
		value && setProfile('');
	}

	const addNewGroup = () => {
		setShowGroupInput(true);
		if (inputValue) {
			hasError && setHasError(false);
			addOneGroup();
		} else {
			setHasError(true);
		}
	}

	const closeGroupInput = () => {
		setShowGroupInput(false);
		setInputValue('');
		setHasError(false);
	};

	const isDisabled = isEditData || !partner || !company || (!cloneProfile ? !profile : false) || !group;

	if (showConfirmModal) {
		return (
			<ModalDelete
				title={t('titleDevicesMigration')}
				content={t('modalDeleteContent', { length: selectedDevices.length, device: selectedDevices.length > 1 ? 'devices' : 'device', company: `"${company}"` })}
				deleteBtnName={t('btnConfirm')}
				deleteModal={saveChanges}
				showClose={true}
				closeBtnName={t('btnCancel')}
				closeModal={() => setShowConfirmModal(false)}
			/>)
	}

	return (
		<Modal
			show
			onHide={onHide}
			className="devices-migration-modal modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('titleDevicesMigration')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{!migratingDevices.length ?
					(<div className="container">
						<label className="title">{t('textSelectDevices')}</label>
						<div className="company-select-menu">
							<div className="select-company-container">
								{partners.length ? (
									<div className="company-select-wrapper">
										<label className="company-select-label">{t('labelPartner')}</label>
										<AutocompleteComponent
											value={partner}
											items={partners}
											placeholder={partner}
											onChange={(e, value) => {
												setPartner(value);
												setIsEditData(true);
											}}
											onSelect={(value) => {
												setPartner(value);
												setCompany('');
												getCompanies(value);
												setIsEditData(false);
											}}
											clear={() => {
												setPartner('');
											}}
											name="Partners"
										/>
									</div>
								) : null}
								<div className="company-select-wrapper">
									<label className="company-select-label">{t('labelCompany')}</label>
									<AutocompleteComponent
										value={company}
										items={companies.map(e => (e = e.name))}
										placeholder={company}
										onChange={(e, value) => {
											setCompany(value);
											setIsEditData(true);
										}}
										onSelect={(value) => {
											setCompany(value);
											getProfiles(partner, value);
											getGroups(partner, value);
											setIsEditData(false);
										}}
										clear={() => {
											setCompany('');
										}}
										name="Companies"
									/>
								</div>
								<div className="company-select-wrapper profile">
									<label className="company-select-label">
										{t('labelProfile')}
									</label>
									<AutocompleteComponent
										value={!cloneProfile ? profile : ''}
										items={profiles.map(e => (e = e.name))}
										placeholder={!cloneProfile ? profile : ''}
										onChange={(e, value) => {
											if (!cloneProfile) {
												setProfile(value);
												setIsEditData(true);
											}
										}}
										onSelect={(value) => {
											if (!cloneProfile) {
												setProfile(value);
												setIsEditData(false);
											}
										}}
										clear={() => {
											setProfile('');
										}}
										name="Profiles"
									/>
									<div className="select-clone-profile">
										<label>
											<Toggle
												checked={cloneProfile}
												onChange={toggleCloneProfile}
											/>
											<span>{t('labelClone')}</span>
										</label>
									</div>
								</div>
								<div className="company-select-wrapper group">
									<label className="company-select-label">{t('labelGroup')}</label>
									<AutocompleteComponent
										value={group}
										items={groups.map(e => (e = e.group_name))}
										placeholder={group}
										onChange={(e, value) => {
											setGroup(value);
											setIsEditData(true);
										}}
										onSelect={(value) => {
											setGroup(value);
											setIsEditData(false);
										}}
										clear={() => {
											setGroup('');
										}}
										name="Groups"
									/>
									<CustomButton
										variant="primary"
										onClick={() => setShowGroupInput(true)}
										disabled={showGroupInput}
									>
										{t('labelAddGroup')}
									</CustomButton>
								</div>
								{showGroupInput &&
									<div className="company-select-wrapper add-group">
										<label className="company-select-label">{t('labelNewGroup')}</label>
										<input className={`inputGroup ${hasError ? 'has-error' : ''}`} type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
										<div className="btn-group">
											<CustomButton
												variant="primary"
												onClick={addNewGroup}
											>
												{t('labelAdd')}
											</CustomButton>
											<CustomButton
												variant="primary"
												onClick={closeGroupInput}>
												{t('labelClose')}
											</CustomButton>
										</div>
									</div>
								}
							</div>
						</div>
					</div>) :
					(<div className="container">
						<div className="migrating-devices-list">
							<p>{t('textMigratingDevices')}</p>
							{migratingDevices.map((device, index) => (
								<ul key={index} className="device-item">
									<li>{device.vehicle_name || device.device_id}</li>
								</ul>
							))}
						</div>
					</div>)
				}
			</Modal.Body>
			<Modal.Footer>
				{!migratingDevices.length ?
					<CustomButton
						variant="primary"
						onClick={() => { setShowConfirmModal(true) }}
						disabled={isDisabled}>
						{t('labelMigrate')}
					</CustomButton> :
					<CustomButton
						variant="primary"
						onClick={onHide}>
						{t('labelClose')}
					</CustomButton>}
			</Modal.Footer>
			{loaderModal}
		</Modal>
	)
}

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(ModalDevicesMigration);
